/**
 * main.js
 *
 */

// Components
import App from "./App.vue";

// Composables
import { createApp } from "vue";
import vuetify from "./plugins/vuetify";
import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueApexCharts from "vue3-apexcharts";
import piniaPersist from "pinia-plugin-persist";
import PerfectScrollbar from "vue3-perfect-scrollbar";
import "@/styles/main.scss";
import router from "./router";
import i18n from "./plugins/i18n";
import "vue3-lottie/dist/style.css";
import Vue3Lottie from "vue3-lottie";
import vueNumeral from "./plugins/numeral";
import { getDeviceId } from "./utils/deviceUtils";

const pinia = createPinia();
pinia.use(piniaPersist);
const app = createApp(App);

// Initialize device ID when app starts
console.log('Application starting with Device ID:', getDeviceId());

app.use(router);
app.use(PerfectScrollbar);
app.use(VueVirtualScroller);
app.use(VueApexCharts);
app.use(pinia);
app.use(i18n);
app.use(Vue3Lottie, { name: "LottieAnimation" });
app.use(vuetify);
app.use(vueNumeral);
app.mount("#app");
